<template>
	<div v-if="widgetReady" class="row">
		<div class="col-md-12 wl-radio">
			<div class="form-check ">
				<input v-model="model" class="form-check-input btn-default" type="radio" name="exampleRadios" id="effStartDate"
					   v-bind:value="today">
				<label class="form-check-label label-font" for="effStartDate">
					Today ({{ today | shortDate }})
				</label>
			</div>
			<div class="form-check">
				<input v-model="model" class="form-check-input" type="radio" name="exampleRadios" id="firstOfNextMonth"
					   v-bind:value="firstOfNextMonth">
				<label class="form-check-label label-font" for="firstOfNextMonth">
					Start of Next Month ({{ firstOfNextMonth | shortDate }})
				</label>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: "EffectiveDate",
		props: {
			value: {
				type: [String],
				required: true,
			},
			firstOfNextMonth: {type: String, required: true}
		},
		data() {
			return {
				model: this.value,
				today: null,
				widgetReady: false
			};
		},
		watch: {
			model(value) {
				this.$emit('input', value);
			}
		},
		mounted() {
			this.today = this.model;
			this.widgetReady = true;
		}
	}
</script>

<style scoped>


	.form-check {
		padding-left: 0;
	}

	[type="radio"] + label:before, [type="radio"] + label:after {
		top: 3px;
	}

	[type="radio"]:not(:checked) + label, [type="radio"]:checked + label {
		font-size: 16px;
	}
</style>